module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Darkest-Minds-The.b597414.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Darkest-Minds-The.jpg
// module id = 6zuA
// module chunks = 0